import React from 'react';

import {RunsDataQuery, toRunsDataQuery} from '../../containers/RunsDataLoader';
import * as Panels from '../../util/panels';
import * as Query from '../../util/queryts';
import {ParameterImportanceConfig} from './common';

const PANEL_TYPE = 'Parameter Importance';

function transformQuery(query: Query.Query, config: any): RunsDataQuery {
  const result = toRunsDataQuery(
    query,
    {selectionsAsFilters: true},
    {fullConfig: true, fullSummary: true}
  );
  return result;
}

export const Spec: Panels.PanelSpec<
  typeof PANEL_TYPE,
  ParameterImportanceConfig
> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
  noEditMode: true,
  icon: 'panel-importance',
};
